import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { MeetingsList } from '../components/MeetingsList';

export default function MyMeetings() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F8FAFC] px-4 py-6 sm:px-16 sm:py-10">
      <div className="mx-auto max-w-3xl">
        <button
          onClick={() => navigate('/')}
          data-testid="my-meetings-back-btn"
          className="mb-6 flex items-center gap-2 rounded-full py-2 font-body text-sm text-slate-500 hover:text-slate-900"
        >
          <ArrowLeft className="h-4 w-4" /> 返回首页
        </button>
        <h1 className="mb-6 font-heading text-2xl font-semibold text-slate-900 sm:text-3xl">我的会议记录</h1>
        <MeetingsList />
      </div>
    </div>
  );
}
